module.exports = __webpack_public_path__ + "img/dress1.f0ef8930.jpeg";